import React, { useState, useEffect, useCallback } from 'react';
import { Button, Table, Modal, Form, Spinner, Alert } from 'react-bootstrap';
import PerfectScrollbar from 'react-perfect-scrollbar';
import Select from 'react-select';
import FixRequiredSelect from '../../components/sis/modalcliente/FixRequiredSelect';
import { getAllPaciente } from '../../../api/pacienteApi';
import { getAllUsuario } from '../../../api/usuarioApi';
import { getgastosbyliquidacion, AddGasto, EditGasto, deleteGasto } from '../../../api/marcacionApi';
import Swal from 'sweetalert2';

const Gastos = ({ metodo = 'OPERATIVA' }) => {
  const [showGastoModal, setShowGastoModal] = useState(false);
  const [gastos, setGastos] = useState([]);
  const [filteredGastos, setFilteredGastos] = useState([]);
  const [pacientes, setPacientes] = useState([]);
  const [usuarios, setUsuarios] = useState([]);
  const [isEditingGasto, setIsEditingGasto] = useState(false);
  const [currentGasto, setCurrentGasto] = useState(null);
  const [loadingStates, setLoadingStates] = useState({
    fetchingGastos: false,
    addingGasto: false,
    editingGasto: false,
    deletingGasto: false,
    fetchingGastoModalData: false,
  });
  const [formData, setFormData] = useState({
    gasto: '',
    monto: '',
    paraTarifa: true,
    paraHonorario: true,
    fecha: '',
    hora: '',
    factura: '',
  });
  const [formData3, setFormData3] = useState({});
  const [errors, setErrors] = useState({});
  const [filterData, setFilterData] = useState({
    fecha: '',
    idPaciente: null,
  });

  const setLoading = (key, value) => {
    setLoadingStates((prev) => ({ ...prev, [key]: value }));
  };

  const fetchPacientes = useCallback(async () => {
    try {
      const response = await getAllPaciente();
      setPacientes(response);
    } catch (error) {
      console.error('Error fetching pacientes:', error);
    }
  }, []);

  const fetchUsuarios = useCallback(async () => {
    try {
      const response = await getAllUsuario();
      const filteredUsuarios = response.filter((user) => user.estaActivo !== 'Inactivo');
      setUsuarios(filteredUsuarios);
    } catch (error) {
      console.error('Error fetching usuarios:', error);
    }
  }, []);

  // Trae TODO; el filtrado por metodo lo hace applyFilters
  const fetchGastos = useCallback(async () => {
    try {
      setLoading('fetchingGastos', true);
      const response = await getgastosbyliquidacion(0);
      const list = Array.isArray(response) ? response : [];
      setGastos(list);
      setFilteredGastos(list); // luego applyFilters ajusta
    } catch (error) {
      console.error('Error fetching gastos:', error);
      setErrors({ gastos: 'Error al cargar los gastos. Intente nuevamente.' });
    } finally {
      setLoading('fetchingGastos', false);
    }
  }, []);

  const handleShowGastoModal = async (gasto = null) => {
    try {
      setLoading('fetchingGastoModalData', true);
      await Promise.all([fetchPacientes(), fetchUsuarios()]);
      if (gasto) {
        setIsEditingGasto(true);
        setCurrentGasto(gasto);
        setFormData({
          gasto: gasto.gasto,
          monto: formatNumber(gasto.monto),
          paraTarifa: gasto.paraTarifa === 'SI',
          paraHonorario: gasto.paraHonorario === 'SI',
          fecha: gasto.fecha,
          hora: gasto.hora,
          factura: gasto.factura || '',
        });
        setFormData3({
          idPaciente: gasto.idPaciente || 0,
          paciente: gasto.paciente || 'Otros',
          idUsuario: gasto.idUsuario || 0,
          usuario: gasto.usuario || 'Otros',
        });
      } else {
        setIsEditingGasto(false);
        setCurrentGasto(null);
        setFormData({
          gasto: '',
          monto: '',
          paraTarifa: true,
          paraHonorario: true,
          fecha: '',
          hora: '',
          factura: '',
        });
        setFormData3({});
      }
      setShowGastoModal(true);
    } catch (err) {
      console.error(err);
      setErrors({ submit: 'Error al cargar los datos. Intente nuevamente.' });
    } finally {
      setLoading('fetchingGastoModalData', false);
    }
  };

  const handleCloseGastoModal = () => {
    setShowGastoModal(false);
    setFormData({
      gasto: '',
      monto: '',
      paraTarifa: true,
      paraHonorario: true,
      fecha: '',
      hora: '',
      factura: '',
    });
    setFormData3({});
    setErrors({});
    setIsEditingGasto(false);
    setCurrentGasto(null);
    setLoading('addingGasto', false);
    setLoading('editingGasto', false);
  };

  const handleDeleteGasto = async (idGasto) => {
    const result = await Swal.fire({
      title: '¿Estás seguro?',
      text: 'No podrás revertir esta acción.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sí, eliminar',
      cancelButtonText: 'Cancelar',
    });
    if (result.isConfirmed) {
      setLoading('deletingGasto', true);
      try {
        await deleteGasto(idGasto);
        await fetchGastos();
        Swal.fire({
          title: 'Eliminado',
          text: 'El gasto ha sido eliminado.',
          icon: 'success',
          timer: 1500,
          showConfirmButton: false,
        });
      } catch (error) {
        console.error('Error al eliminar el gasto:', error);
        setErrors({ gastos: 'Error al eliminar el gasto. Intente nuevamente.' });
      } finally {
        setLoading('deletingGasto', false);
      }
    }
  };

  // Inputs
  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    if (name === 'monto') {
      let rawValue = value.replace(/[^\d\-,.]/g, '');
      rawValue = rawValue.replace(/(?!^)-/g, '');
      setFormData((prev) => ({ ...prev, [name]: rawValue }));
    } else {
      setFormData((prev) => ({ ...prev, [name]: type === 'checkbox' ? checked : value }));
    }
    setErrors((prev) => ({ ...prev, [name]: '' }));
  };

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilterData((prev) => ({ ...prev, [name]: value }));
  };

  const handlePacienteFilterChange = (selectedOption) => {
    setFilterData((prev) => ({
      ...prev,
      idPaciente: selectedOption ? selectedOption.value : null,
    }));
  };

  // Filtro centralizado
  const applyFilters = useCallback(() => {
    let filtered = gastos;
    const metodoNorm = String(metodo || '').trim().toLowerCase();

    if (metodoNorm === 'operativa') {
      filtered = filtered.filter(
        (g) => String(g?.metodo ?? '').trim().toLowerCase() === 'operativa'
      );
    } else if (metodoNorm === 'administrativo') {
      // no filtra por método → muestra todos
    } // cualquier otro valor: no filtra por método

    if (filterData.fecha) {
      filtered = filtered.filter((g) => g.fecha === filterData.fecha);
    }

    if (filterData.idPaciente !== null) {
      filtered = filtered.filter(
        (g) =>
          g.idPaciente === filterData.idPaciente ||
          (filterData.idPaciente === 0 && (!g.idPaciente || g.paciente === 'Otros'))
      );
    }

    setFilteredGastos(filtered);
  }, [gastos, filterData, metodo]);

  const validateGastoForm = () => {
    const newErrors = {};
    if (!formData.gasto.trim()) newErrors.gasto = 'El detalle es requerido';
    const montoValue = parseFloat(formData.monto.toString().replace(/\./g, '').replace(',', '.'));
    if (!formData.monto || montoValue === 0 || isNaN(montoValue)) newErrors.monto = 'El monto no puede ser cero';
    if (!formData.fecha) newErrors.fecha = 'La fecha es requerida';
    if (!formData.hora) newErrors.hora = 'La hora es requerida';
    return newErrors;
  };

  const handleGastoSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = validateGastoForm();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    setLoading(isEditingGasto ? 'editingGasto' : 'addingGasto', true);
    try {
      // Conservar método original al editar; usar el prop al crear
      const metodoToSend = isEditingGasto ? (currentGasto?.metodo ?? metodo) : metodo;
      const metodoNormalizado = String(metodoToSend).trim().toUpperCase();

      const combinedFormData = {
        idgastoenfermeria: isEditingGasto ? currentGasto.idgastoenfermeria : null,
        gasto: formData.gasto,
        idPaciente: formData3.idPaciente || 0,
        idUsuario: formData3.idUsuario || 0,
        idliquidacion: 0,
        monto: parseFloat(formData.monto.toString().replace(/\./g, '').replace(',', '.')),
        paciente: formData3.paciente || 'Otros',
        paraHonorario: formData.paraHonorario ? 'SI' : 'NO',
        paraTarifa: formData.paraTarifa ? 'SI' : 'NO',
        usuario: formData3.usuario || 'Otros',
        fecha: formData.fecha,
        hora: formData.hora,
        metodo: metodoNormalizado,
        factura: formData.factura || '',
      };

      if (isEditingGasto) {
        await EditGasto(combinedFormData);
      } else {
        await AddGasto(combinedFormData);
      }
      await fetchGastos();
      handleCloseGastoModal();
      Swal.fire({
        title: isEditingGasto ? 'Actualizado' : 'Agregado',
        text: `El gasto ha sido ${isEditingGasto ? 'actualizado' : 'agregado'} con éxito.`,
        icon: 'success',
        timer: 1500,
        showConfirmButton: false,
      });
    } catch (error) {
      console.error('Error submitting gasto:', error);
      setErrors({ submit: 'Error al guardar el gasto. Intente nuevamente.' });
    } finally {
      setLoading(isEditingGasto ? 'editingGasto' : 'addingGasto', false);
    }
  };

  const formatNumber = (value) => {
    if (value === '' || value === undefined || value === null) return '';
    const num = parseFloat(value.toString().replace(/\./g, '').replace(',', '.'));
    if (isNaN(num)) return '';
    return num.toLocaleString('es-ES', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
  };

  const pacienteOptions = pacientes.map((pac) => ({
    value: pac.IdPacientes,
    label: `${pac.NombrePaciente}`,
  }));

  const usuarioOptions = usuarios.map((user) => ({
    value: user.IdUsuario,
    label: user.Usuario,
  }));

  useEffect(() => {
    fetchPacientes();
    fetchUsuarios();
    fetchGastos();
  }, [fetchPacientes, fetchUsuarios, fetchGastos]);

  useEffect(() => {
    applyFilters();
  }, [filterData, gastos, applyFilters]);

  return (
    <div className="card">
      <div className="card-header border-0 pb-0">
        <div className="d-flex gap-2 align-items-center">
          <Button
            variant="primary"
            size="sm"
            onClick={() => handleShowGastoModal()}
            disabled={loadingStates.addingGasto || loadingStates.fetchingGastos || loadingStates.fetchingGastoModalData}
          >
            {loadingStates.addingGasto || loadingStates.fetchingGastoModalData ? (
              <>
                <Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                  className="me-2"
                />
                Cargando...
              </>
            ) : (
              'Agregar Gastos'
            )}
          </Button>

          <Form.Group className="me-2">
            <Form.Label>Filtrar por Fecha</Form.Label>
            <Form.Control
              type="date"
              name="fecha"
              value={filterData.fecha}
              onChange={handleFilterChange}
              disabled={loadingStates.fetchingGastos}
            />
          </Form.Group>

          <Form.Group className="me-2" style={{ minWidth: '200px' }}>
            <Form.Label>Filtrar por Paciente</Form.Label>
            <FixRequiredSelect
              SelectComponent={Select}
              options={[{ label: 'Todos', value: null }, { label: 'Otros', value: 0 }, ...pacienteOptions]}
              isSearchable
              value={
                ([{ label: 'Todos', value: null }, { label: 'Otros', value: 0 }, ...pacienteOptions])
                  .find((option) => option.value === filterData.idPaciente) || { label: 'Todos', value: null }
              }
              onChange={handlePacienteFilterChange}
              placeholder="Seleccione un paciente"
              isLoading={pacientes.length === 0}
              loadingMessage={() => 'Cargando'}
              noOptionsMessage={() => 'Sin Datos'}
              isDisabled={loadingStates.fetchingGastos}
            />
          </Form.Group>
        </div>
      </div>

      <div className="card-body">
        {errors.gastos && <Alert variant="danger">{errors.gastos}</Alert>}
        {loadingStates.fetchingGastos ? (
          <div className="text-center">
            <Spinner animation="border" role="status">
              <span className="visually-hidden">Cargando...</span>
            </Spinner>
          </div>
        ) : filteredGastos.length === 0 ? (
          <p>No hay gastos que coincidan con los filtros.</p>
        ) : (
          <PerfectScrollbar>
            <table className="table verticle-middle table-responsive-md">
              <thead style={{ backgroundColor: '#304a97' }}>
                <tr>
                  <th style={{ width: '15%' }}>Fecha hora</th>
                  <th style={{ width: '15%' }}>Factura</th>
                  <th style={{ width: '20%' }}>Usuario</th>
                  <th style={{ width: '20%' }}>Prof.</th>
                  <th style={{ width: '55%' }}>Detalle</th>
                  <th style={{ width: '5%' }}>Monto</th>
                  <th style={{ width: '5%' }}>Opc.</th>
                </tr>
              </thead>
              <tbody>
                {filteredGastos.map((gasto, index) => (
                  <tr key={index}>
                    <td>{gasto.fecha} {gasto.hora}</td>
                    <td>{gasto.factura || '-'}</td>
                    <td>
                      <div>{gasto.paciente || 'Otros'}</div>
                    </td>
                    <td>{gasto.usuario || 'Otros'}</td>
                    <td
                      style={{
                        maxWidth: '150px',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'wrap',
                      }}
                    >
                      <div>{gasto.gasto}</div>
                    </td>
                    <td>{formatNumber(gasto.monto)}</td>
                    <td>
                      <div className="d-flex justify-content-center">
                        <li
                          className="btn btn-primary shadow btn-xs sharp me-1"
                          onClick={() => handleShowGastoModal(gasto)}
                          disabled={loadingStates.editingGasto || loadingStates.deletingGasto}
                        >
                          {loadingStates.editingGasto && currentGasto?.idgastoenfermeria === gasto.idgastoenfermeria ? (
                            <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                          ) : (
                            <i className="fas fa-pencil-alt"></i>
                          )}
                        </li>
                        <li
                          className="btn btn-danger shadow btn-xs sharp me-1"
                          onClick={() => handleDeleteGasto(gasto.idgastoenfermeria)}
                          disabled={loadingStates.editingGasto || loadingStates.deletingGasto}
                        >
                          {loadingStates.deletingGasto && currentGasto?.idgastoenfermeria === gasto.idgastoenfermeria ? (
                            <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                          ) : (
                            <i className="fa fa-trash"></i>
                          )}
                        </li>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </PerfectScrollbar>
        )}
      </div>

      <Modal show={showGastoModal} onHide={handleCloseGastoModal}>
        <Modal.Header closeButton>
          <Modal.Title>{isEditingGasto ? 'Editar Gasto' : 'Agregar Gasto'}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {errors.submit && <Alert variant="danger">{errors.submit}</Alert>}
          <Form onSubmit={handleGastoSubmit}>
            <Form.Group className="mb-3">
              <Form.Label>
                Profesional <span className="text-danger">*</span>
              </Form.Label>
              <FixRequiredSelect
                SelectComponent={Select}
                options={[{ label: 'Otros', value: 0 }, ...usuarioOptions]}
                isSearchable
                required
                value={usuarioOptions.find((option) => option.value === formData3.idUsuario) || { label: 'Otros', value: 0 }}
                onChange={(e) => {
                  setFormData3((prev) => ({ ...prev, idUsuario: e.value, usuario: e.label }));
                  setErrors((prev) => ({ ...prev, idUsuario: '' }));
                }}
                placeholder="Seleccione un profesional"
                isLoading={usuarios.length === 0}
                loadingMessage={() => 'Cargando'}
                noOptionsMessage={() => 'Sin Datos'}
                isDisabled={loadingStates.addingGasto || loadingStates.editingGasto}
              />
              {errors.idUsuario && <Form.Text className="text-danger">{errors.idUsuario}</Form.Text>}
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>
                Paciente <span className="text-danger">*</span>
              </Form.Label>
              <FixRequiredSelect
                SelectComponent={Select}
                options={[{ label: 'Otros', value: 0 }, ...pacienteOptions]}
                isSearchable
                required
                value={pacienteOptions.find((option) => option.value === formData3.idPaciente) || { label: 'Otros', value: 0 }}
                onChange={(e) => {
                  setFormData3((prev) => ({ ...prev, idPaciente: e.value, paciente: e.label }));
                  setErrors((prev) => ({ ...prev, idPaciente: '' }));
                }}
                placeholder="Seleccione un paciente"
                isLoading={pacientes.length === 0}
                loadingMessage={() => 'Cargando'}
                noOptionsMessage={() => 'Sin Datos'}
                isDisabled={loadingStates.addingGasto || loadingStates.editingGasto}
              />
              {errors.idPaciente && <Form.Text className="text-danger">{errors.idPaciente}</Form.Text>}
            </Form.Group>

            <Form.Group className="mb-3" controlId="formFecha">
              <Form.Label>Fecha</Form.Label>
              <Form.Control
                type="date"
                name="fecha"
                value={formData.fecha}
                onChange={handleInputChange}
                required
                disabled={loadingStates.addingGasto || loadingStates.editingGasto}
              />
              {errors.fecha && <Form.Text className="text-danger">{errors.fecha}</Form.Text>}
            </Form.Group>

            <Form.Group className="mb-3" controlId="formHora">
              <Form.Label>Hora</Form.Label>
              <Form.Control
                type="time"
                name="hora"
                value={formData.hora}
                onChange={handleInputChange}
                required
                disabled={loadingStates.addingGasto || loadingStates.editingGasto}
              />
              {errors.hora && <Form.Text className="text-danger">{errors.hora}</Form.Text>}
            </Form.Group>

            <Form.Group className="mb-3" controlId="formFactura">
              <Form.Label>Factura</Form.Label>
              <Form.Control
                type="text"
                name="factura"
                value={formData.factura}
                onChange={handleInputChange}
                placeholder="Número / Código de factura"
                disabled={loadingStates.addingGasto || loadingStates.editingGasto}
                maxLength={50}
              />
              {errors.factura && <Form.Text className="text-danger">{errors.factura}</Form.Text>}
            </Form.Group>

            <Form.Group className="mb-3" controlId="formGasto">
              <Form.Label>Detalle</Form.Label>
              <Form.Control
                as="textarea"
                rows={7}
                name="gasto"
                value={formData.gasto}
                onChange={handleInputChange}
                placeholder="Ingrese el detalle"
                required
                disabled={loadingStates.addingGasto || loadingStates.editingGasto}
              />
              {errors.gasto && <Form.Text className="text-danger">{errors.gasto}</Form.Text>}
            </Form.Group>

            <Form.Group className="mb-3" controlId="formMonto">
              <Form.Label>Monto</Form.Label>
              <Form.Control
                type="text"
                name="monto"
                value={formData.monto}
                onChange={handleInputChange}
                placeholder="Ingrese el monto (puede ser negativo)"
                required
                disabled={loadingStates.addingGasto || loadingStates.editingGasto}
                inputMode="decimal"
                pattern="^-?\\d*[.,]?\\d*$"
              />
              <div>
                <small>
                  Vista previa: <strong>{formatNumber(formData.monto)}</strong>
                </small>
              </div>
              {errors.monto && <Form.Text className="text-danger">{errors.monto}</Form.Text>}
            </Form.Group>

            <Form.Group className="mb-3" controlId="formParaTarifa">
              <Form.Check
                type="checkbox"
                name="paraTarifa"
                label="Para Tarifa"
                checked={formData.paraTarifa}
                onChange={handleInputChange}
                disabled={loadingStates.addingGasto || loadingStates.editingGasto}
              />
            </Form.Group>

            <Form.Group className="mb-3" controlId="formParaHonorario">
              <Form.Check
                type="checkbox"
                name="paraHonorario"
                label="Para Honorario"
                checked={formData.paraHonorario}
                onChange={handleInputChange}
                disabled={loadingStates.addingGasto || loadingStates.editingGasto}
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="danger"
            onClick={handleCloseGastoModal}
            disabled={loadingStates.addingGasto || loadingStates.editingGasto}
          >
            Cerrar
          </Button>
          <Button
            variant="primary"
            onClick={handleGastoSubmit}
            disabled={loadingStates.addingGasto || loadingStates.editingGasto}
          >
            {loadingStates.addingGasto || loadingStates.editingGasto ? (
              <>
                <Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                  className="me-2"
                />
                {isEditingGasto ? 'Actualizando...' : 'Agregando...'}
              </>
            ) : (
              isEditingGasto ? 'Actualizar' : 'Agregar'
            )}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default Gastos;
